/**
 * @author xiaoping
 * @email edwardhjp@gmail.com
 * @create date 2017-08-24 04:09:41
 * @modify date 2017-08-24 04:09:41
 * @desc [demo入口文件]
*/

import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./demo/main.js